import { defineStore } from "pinia";
import piniaPersistConfig from "@/stores/helper/persist";

interface RunTimeConfigPublic {
    userNodeEnv: string;
    publicPath: string;
    routerMode?: string;
    apiUrl: string;
    baseFileUrl?: string;
    originUrl: string;
    wsUrl: string;
    ships66CodeJs?: string;
    tenantId: string;
}

export const useRuntimeConfig = defineStore("runtimeConfig", {
    state: (): {
        public: RunTimeConfigPublic;
    } => ({
        public: {
            userNodeEnv: import.meta.env.VITE_USER_NODE_ENV || "",
            publicPath: import.meta.env.VITE_PUBLIC_PATH || "",
            apiUrl: import.meta.env.VITE_API_URL || "",
            originUrl: import.meta.env.VITE_ORIGIN_URL || "",
            wsUrl: import.meta.env.VITE_WS_URL || "",
            tenantId: import.meta.env.VITE_TENANT_ID || ""
        }
    }),
    persist: piniaPersistConfig("zhihao-web-runtime-config")
});
